import { isInIframe } from 'helpers/isInIframe'
import { createRemoteFetch } from './createRemoteFetch'
export * as fetchInterceptor from './host/fetchInterceptor'
export { useHostFetch } from './host/useHostFetch'
export { type SerializedRequest, type SerializedResponse } from './serialize'
import { wlsyFetch } from './wlsyFetch'

export const microFrontendFetch =
  () =>
  (options: Request): Promise<Response> =>
    isInIframe() ? createRemoteFetch(options) : wlsyFetch(options)
